'use client';

import React, { useState } from 'react';

import Image from 'next/image';

import PhotoFrame from '@/assets/images/imagen2.jpg';
import KeyChain from '@/assets/images/llavero.png';
import PlayVideoButton from '@/assets/images/play-btn.svg';
import VideoModal from '@/components/common/VideoModal';
import { HeadingTwo } from '@/components/Typography/Heading';
import Paragraph from '@/components/Typography/Paragraph';

const SectionFrames = () => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  return (
    <div className="max-w-[67.5rem] sm:mx-[30px] sm:mb-[7.8rem] md:mb-[10.5rem] md:mt-[6.25rem] lg:mx-auto">
      <div className="-mb-[15px] grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-2">
        <div className="">
          <Image
            src={PhotoFrame}
            alt="Frame"
            loading="lazy"
            placeholder="blur"
            className="w-auto object-cover lg:h-auto lg:max-w-[487px] lg:object-contain"
          />
        </div>
        <div className="">
          <div className="relative z-10 mx-auto ml-0 rounded-[12px] bg-white px-[30px] pt-[40px] pb-[45px] shadow-solution-card lg:mt-[3.125rem] lg:-ml-[85px] lg:w-[582px] lg:pl-[33px] lg:pr-[26px]">
            <HeadingTwo className="mb-[26px] font-circular-std-medium">
              Are You Willing To <br /> Compromise Your Pet&apos;s Health?
            </HeadingTwo>
            <Paragraph className="mb-[25px] lg:pr-10" variant="light-gray">
              We&apos;re not either! With over 15 years of experience as a CEO in the pet space Roger has seen first
              hand the impact of companies putting profits before pets.
            </Paragraph>
            <Paragraph className="sm:mb-[25px] lg:mb-0 lg:pr-10" variant="light-gray">
              Because of that, he founded pawTree with a commitment to exceed industry standards by simply living up to
              our own!
            </Paragraph>
            <div className="items-end justify-between lg:flex">
              <div
                className="flex cursor-pointer items-center sm:-ml-[15px] lg:ml-0"
                onClick={() => setIsVideoModalOpen(true)}
              >
                <Image
                  src={PlayVideoButton}
                  loading="lazy"
                  alt="Play Button"
                  className="sm:mt cursor-pointer sm:w-[68px] lg:w-[68px] xs:w-[68px] xxs:w-[68px]"
                />
                <p className="mr-auto ml-[10px] font-circular-std-medium text-[1rem] text-grayscale-96">
                  <span className="block uppercase tracking-[1.6px]">Learn More</span>
                </p>
              </div>
              <Image
                src={KeyChain}
                loading="lazy"
                alt="Key chain"
                className="sm:relative sm:-mt-5 sm:-mr-3 sm:ml-auto sm:w-[134px] lg:-mt-1 lg:mr-[5px] lg:w-[134px] xs:w-[134px] xxs:w-[134px]"
              />
            </div>
          </div>
        </div>
      </div>
      <VideoModal
        isOpen={isVideoModalOpen}
        onClose={() => setIsVideoModalOpen(false)}
        className="!bg-transparent !shadow-none"
        closeBtnClassName="!absolute !right-5 !top-[35px] !bg-white !rounded-full"
        video="https://www.youtube.com/embed/2bldSsPxfzw?si=ZboHX7WMWLRMTh9T"
      />
    </div>
  );
};

export default SectionFrames;
